import { BaseApiService } from "../services/baseApiService";
import ShowNotifications from "../utils/notification";

class ApiProvider extends BaseApiService {
    constructor() {
        super();
    }

    async getUserRoleList(input) {
        try {
            const response = await this.get(`/user-role`, input);

            if (response.success) {
                return { status: true, response: response.data };
            } else {
                console.error("Failed to fetch user roles:", response.message ?? "Something went wrong");
                return { status: false, response: response.data };
            }
        } catch (error) {
            console.error("Error fetching user roles:", error);
            return { status: false, response: null };
        }
    }

    async createRole(input) {
        try {
            const response = await this.post("/user-role", input, "Role created successfully");
            if (response.success) {
                return { status: true, response: response.data };
            }
            return { status: false, response: response.data };
        } catch (error) {
            console.error("Create role error:", error);
            return { status: false, response: null };
        }
    }

    async updateRole(id, input) {
        try {
            const response = await this.put(`/user-role/${id}`, input, "Role updated successfully");
            if (response.success) {
                return { status: true, response: response.data };
            }
            return { status: false, response: response.data };
        } catch (error) {
            console.error("Update role error:", error);
            return { status: false, response: null };
        }
    }

    async deleteRole(id, updatedRole) {
        try {
            const response = await this.put(`/user-role/${id}`, updatedRole, "Role deleted successfully");
            if (response.success) {
                return { status: true, response: response.data };
            }
            return { status: false, response: response.data };
        } catch (error) {
            console.error("Delete failed:", error);
            return null;
        }
    }
}

const rolesApiProvider = new ApiProvider();
export default rolesApiProvider;